import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { WrapApp } from "WrapApp"; // インポートパスを修正
import "common/styles/global/index.css"; // CSSファイルをインポート
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { loadCustomFonts } from "common/utils/fontLoader";
import { getRedirectPath } from "common/utils/urlUtil";

// フォント事前読み込みとfont-familyの動的適用
loadCustomFonts();

const baseUrl =
  document.getElementsByTagName("base")[0]?.getAttribute("href") || "/";
const rootElement = document.getElementById("root");
// REACT_APP_API_URL未設定時のフォールバックは、フロントの開発サーバーのポート（3000/3001等）ではなく
// 実際のバックエンドのポート（package.json の "proxy" と同じ）を指す必要がある。
axios.defaults.baseURL =
  process.env.REACT_APP_API_URL || "https://localhost:8001";

axios.defaults.withCredentials = true; // Cookieを送信するための設定

// 共通ヘッダー設定
axios.interceptors.request.use((config) => {
  config.headers["X-Client-Url"] = window.location.href;
  return config;
});

// axios グローバルエラーハンドラー: サーバー障害（応答なし）の場合、障害案内画面に移動
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const currentPath = window.location.pathname;
    const requestUrl = error.config?.url || "";
    // 自治体プレフィックスを保持したサーバーエラーパスを生成
    const serverErrorPath = getRedirectPath("/server-error");

    if (
      currentPath !== serverErrorPath &&
      !error.response && // サーバーからの応答がない場合（ネットワークエラーやサーバーダウン）#103
      !requestUrl.includes("zipcloud.ibsnet.co.jp/api/search") // 郵便番号APIのエラーは除外
    ) {
      window.location.href = serverErrorPath;
    }
    return Promise.reject(error);
  },
);

if (rootElement) {
  // React 18の新しいAPIを使用してルートを作成
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <BrowserRouter basename={baseUrl}>
      <WrapApp />
    </BrowserRouter>,
  );

  // パフォーマンス測定
  reportWebVitals();
} else {
  console.error("Root element with id 'root' not found!");
}
